import { render } from "./UsersCard.vue?vue&type=template&id=3425dd20&scoped=true"
import script from "./UsersCard.vue?vue&type=script&lang=js"
export * from "./UsersCard.vue?vue&type=script&lang=js"

import "./UsersCard.vue?vue&type=style&index=0&id=3425dd20&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3425dd20"]])

export default __exports__